import {
  createFrontendPlugin,
  PageBlueprint,
  ApiBlueprint,
} from '@backstage/frontend-plugin-api';
import {
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { SpecreqClient, specreqApiRef } from './api/SpecreqClient';

export { specreqApiRef };

const specreqApiExtension = ApiBlueprint.make({
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: specreqApiRef,
        deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
        factory: ({ discoveryApi, fetchApi }) =>
          new SpecreqClient(discoveryApi, fetchApi),
      }),
    ),
});

const specreqPageExtension = PageBlueprint.make({
  params: {
    path: '/specreq',
    loader: async () => {
      const { Router } = await import('./components/Router');
      return <Router />;
    },
  },
});

export default createFrontendPlugin({
  pluginId: 'specreq',
  extensions: [specreqApiExtension, specreqPageExtension],
});

// Legacy component kept for direct use in entity pages
export { EntitySpecreqSkillsCard } from './components/EntitySpecreqSkillsCard';
